// extracted by mini-css-extract-plugin
export default {"button":"jGo3a","icon":"qp4EL"};